import Vue from 'vue'
import { decode } from '@/lib/util'
import '../carousel-swiper/carousel-swiper.vue'

export default el => new Vue({
  name: 'Content Carousel',
  el,
  data () {
    const sectionSettings = JSON.parse(decode(el.getAttribute('settings-data'))) || {
      items: [],
      title: '',
      buttonText: '',
      buttonLink: '',
      showContentCarousel: false
    }
    return {
      ...sectionSettings
    }
  }
})